// The workspace a demo request opened (POST /demo-requests' `joinUrl`): the
// teacher panel's join page with a browser handle in its fragment. The page goes
// there at once, so it goes only where the site's own build says the teacher
// panel is - an answer naming another host, another path or an http page under
// an https site is not followed, and the visitor is shown the letter's way in
// instead. The address is built by the server; the page only checks it.

/** The URL to go to, or null when the answer carries none this page may follow. */
export function workspaceDoor(raw: unknown, teacherOrigin: string | undefined, pageProtocol: string): string | null {
  if (typeof raw !== 'string' || !teacherOrigin) return null;
  let door: URL;
  let panel: URL;
  try {
    door = new URL(raw);
    panel = new URL(teacherOrigin);
  } catch {
    return null;
  }
  if (door.origin !== panel.origin) return null;
  // An https site never sends its visitor to an http page; the dev stack, whose
  // site is http too, may.
  if (door.protocol !== 'https:' && pageProtocol === 'https:') return null;
  if (door.pathname !== '/join' || !/^#handle=[A-Za-z0-9_-]+$/.test(door.hash)) return null;
  return door.toString();
}
